<div class="ajax-loading ajax-popup-loading"><div class="loading-icon"></div></div>
<div class="mat-dialog-title" mat-dialog-title="">
    <h2>Cache Purge</h2>
    <button mat-button mat-dialog-close class="close">Cancel</button>
</div>
<div mat-dialog-content class="example-container pt-4 text-dark">
    <h4 class="bold">Are you sure you want to purge all cached video data across the system?</h4>
    <p>This action is irreversible and will clear all video cache. This process will take up to 10 mins. Thank you for the support.</p>
</div>
<div mat-dialog-actions class="row">
    <div class="col-12">
        <div class="text-center py-3 d-flex  justify-content-center"> 
            <button mat-raised-button color="primary" (click)="closeDialog()" type="button" class="btn-outline-black me-3">Cancel</button>
            <button mat-raised-button color="primary" (click)="purgeCache()" type="button" class=" btn-black ">Confirm </button>&nbsp;&nbsp;                
        </div>
    </div>
</div>